import React from 'react';
import { BsLinkedin, BsGithub, BsTwitterX} from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    <div>
    <BsLinkedin />
    </div>
    <div>
    <BsGithub />
    </div>
    <div>
    <BsTwitterX />
    </div>
  </div>
);

export default SocialMedia;